import React, { useRef } from 'react'

import { Tooltip } from '../../../components/Tooltip'
import { TooltipHandle } from '../../../components/Tooltip/Tooltip'

interface IProps {
  tooltip: string
  icon: string
  disabled: boolean
  id?: string
  onClick: (artifact_id?: string) => void
}

export const ArtifactButton: React.FC<IProps> = ({
  icon,
  tooltip,
  id,
  disabled,
  onClick,
}) => {
  const tooltipRef = useRef<TooltipHandle>(null)
  const handleTouchEnd = () => {
    tooltipRef.current?.closeWithDelay()
  }
  const handleClick = () => {
    onClick(id)
  }

  return (
    <>
      <Tooltip
        content={tooltip}
        anchor={`#artifact-${icon}`}
        placement="left"
      />
      <button
        className="tc-artifact-icon align-middle tc-dark-grey-bg"
        disabled={disabled}
        onClick={handleClick}
        id={`artifact-${icon}`}
        onTouchEnd={handleTouchEnd}
      >
        <span className="star-icon star-first large">✦</span>
        <span className="star-icon star-second">✦</span>
        <span className="star-icon star-third medium">✦</span>
        <i className={`fa fa-${icon}`} />
      </button>
    </>
  )
}
